import React, { useEffect, useState } from "react";
import "./CareersHeader.scss";
import bookMarkIco from "../../../../../../assets/bookMarkIco.svg";
import notificationsIco from "../../../../../../assets/notificationsIco.svg";
import Button from "../Button/Button";
import Card from "../Card/Card";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const CareersHeader = ({ careers }) => {
  const [section, setSection] = useState(1);
  const [ids, setIds] = useState({});
  const { aiAgents } = useSelector((state) => state.aiCompanionsReducer);
  const [isAgentPresent, setIsAgentPresent] = useState({
    "college-buddy": false,
    "career-buddy": false,
  });
  const router = useNavigate();

  useEffect(() => {
    if (careers.length > 0) {
      setSection(careers?.length === 0 ? 1 : careers?.length < 2 ? 2 : 3);
    }
  }, [careers]);

  useEffect(() => {
    if (aiAgents?.results && aiAgents.results.length > 0) {
      let obj = {};
      aiAgents.results.forEach((item) => {
        if (item.name === "College Buddy") {
          setIsAgentPresent((prevState) => {
            return {
              ...prevState,
              "college-buddy": true,
            };
          });
        }
        if (item.name === "Career Buddy") {
          setIsAgentPresent((prevState) => {
            return {
              ...prevState,
              "career-buddy": true,
            };
          });
        }
        obj[item.name] = item.id;
      });
      setIds(obj);
    }
  }, [aiAgents]);

  const handleClick = (key, query) => {
    router(
      `/profile/ai-companions/${ids[key]}/${key
        .toLowerCase()
        .replaceAll(" ", "-")}?type=${query}`
    );
  };

  return (
    <>
      {careers && careers?.length > 0 && (
        <div className="recommendations__header">
          <img src={bookMarkIco} alt="book_mark" />
          <h4 className="recommendations__title">Your Careers of Interest</h4>
        </div>
      )}
      {(section === 2 || section === 3) && (
        <div className="careers_of_interest">
          <div className="Recommendations-cont">
            {careers?.map((career, key) => (
              <Card el={career} key={key} />
            ))}
          </div>
        </div>
      )}
      <div className="careers">
        <div className="careers__title-container">
          <img src={notificationsIco} alt="" />
          <p className="careers__title">
            {section === 1
              ? "No saved careers yet"
              : section === 2
              ? "Want to compare or build a plan?"
              : "Next Steps?"}
          </p>
        </div>
        {section === 1 && (
          <>
            <p className="careers__description">
              Find one below that sparks your interest and click “Save this
              Career” to keep it here!
            </p>
            <p className="careers__description">
              Saving a career lets you compare options and unlock personalized
              next steps.
            </p>
          </>
        )}

        {section === 2 && (
          <>
            <p className="careers__description">
              Save at least one more career below to unlock your personalized
              next steps.
            </p>
          </>
        )}

        {section === 3 && (
          <>
            <p className="careers__description-next-steps">
              Click on each career to explore a day on the job, job outlook,
              education requirements, lifestyle expectations, and more — all to
              help you build a plan for the future you want. Or scroll down to
              check out helpful resources made just for you!
            </p>
            <p className="careers__description-next-steps">
              Want deeper insights? Try these:
            </p>

            <div className="careers__button-container">
              <Button
                active={!isAgentPresent["career-buddy"]}
                text="Compare Careers"
                handeClick={() =>
                  handleClick("Career Buddy", "compare-careers")
                }
              />
              <Button
                active={!isAgentPresent["career-buddy"]}
                text="Start an Action Plan"
                handeClick={() =>
                  handleClick("Career Buddy", "start-action-plan")
                }
              />
              <Button
                active={!isAgentPresent["college-buddy"]}
                text="Find Schools & Programs"
                handeClick={() => handleClick("College Buddy", "find-schools")}
              />
            </div>
            <p className="careers__description text-center careers__description__text-semi-bold">
              These features are available with the AI Companions subscription.
            </p>
          </>
        )}
      </div>
    </>
  );
};

export default CareersHeader;
